/* PURPOSE Theme — Main JS */
(function() {

  /* ---- INTERSECTION OBSERVER (fade-up animations) ---- */
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });

  function observeFadeUps(root) {
    (root || document).querySelectorAll('.fade-up:not(.visible)').forEach(function(el) { io.observe(el); });
  }

  /* ---- VIDEO LOOP MANAGER ---- */
  function initVideoLoop(videoId, wrapSelector, playbackRate) {
    var vid = document.getElementById(videoId);
    if (!vid) return null;
    vid.muted = true;
    vid.playbackRate = playbackRate || 1;

    vid.addEventListener('timeupdate', function() {
      if (vid.duration && vid.currentTime >= vid.duration - 0.3) {
        vid.currentTime = 0;
      }
    });

    var wrap = vid.closest(wrapSelector);
    if (!wrap) return null;

    var vidIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { vid.muted = true; vid.play().catch(function(){}); }
        else { vid.pause(); }
      });
    }, { threshold: 0.1 });
    vidIo.observe(wrap);

    return vidIo;
  }

  /* ---- TIMELINE TABS ---- */
  function initTimeline(container) {
    if (!container) return;
    var steps = container.querySelectorAll('.timeline-step');
    var panels = container.querySelectorAll('.timeline-panel');

    function goTo(index) {
      steps.forEach(function(s, i) {
        s.classList.remove('active', 'passed');
        if (i < index) s.classList.add('passed');
        if (i === index) s.classList.add('active');
      });
      panels.forEach(function(p) { p.classList.remove('active'); });
      var target = container.querySelector('.timeline-panel[data-panel="' + index + '"]');
      if (target) target.classList.add('active');
    }

    steps.forEach(function(step, i) {
      step.addEventListener('click', function() { goTo(i); });
    });

    container.querySelectorAll('.panel-cta[data-goto]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        goTo(parseInt(btn.getAttribute('data-goto')));
      });
    });
  }

  /* ---- FAQ ACCORDION ---- */
  function initFaq(container) {
    if (!container) return;
    container.querySelectorAll('.faq-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.faq-item');
        var isOpen = item.classList.contains('open');
        container.querySelectorAll('.faq-item.open').forEach(function(i) {
          i.classList.remove('open');
          i.querySelector('.faq-btn').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---- KLAVIYO FORM ---- */
  function initKlaviyoForm(form) {
    if (!form) return;
    var companyId = form.getAttribute('data-company-id');
    var emailList = form.getAttribute('data-email-list');
    var smsList = form.getAttribute('data-sms-list');
    if (!companyId || !emailList) return;

    var KL_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId;
    var HEADERS = { 'Content-Type': 'application/json', 'revision': '2024-02-15' };

    function payload(listId, attrs) {
      return JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: attrs } }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      });
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = form.querySelector('[type="email"]');
      var phoneInput = form.querySelector('[type="tel"]');
      var btn = form.querySelector('.btn-submit');
      var email = emailInput ? emailInput.value.trim() : '';
      var phone = phoneInput ? phoneInput.value.trim() : '';
      if (!email) return;

      btn.textContent = 'Joining...';
      btn.disabled = true;

      fetch(KL_URL, { method: 'POST', headers: HEADERS, body: payload(emailList, { email: email }) })
        .then(function() {
          if (phone && smsList) {
            var d = phone.replace(/\D/g, '');
            if (d.length >= 10) {
              var pn = d.charAt(0) === '1' ? '+' + d : '+1' + d;
              return fetch(KL_URL, { method: 'POST', headers: HEADERS, body: payload(smsList, { phone_number: pn }) });
            }
          }
        })
        .then(function() {
          form.style.display = 'none';
          var success = form.parentElement.querySelector('.form-success');
          if (success) success.classList.add('show');
        })
        .catch(function(err) {
          console.error(err);
          btn.textContent = 'Claim My Founding Member Spot';
          btn.disabled = false;
        });
    });
  }

  /* ---- INIT ON LOAD ---- */
  document.addEventListener('DOMContentLoaded', function() {
    observeFadeUps();
    initVideoLoop('pv-a', '.product-image-wrap', 0.85);
    initVideoLoop('fv-a', '.feature-image-wrap', 0.55);
    initTimeline(document.querySelector('.timeline-wrap'));
    initFaq(document.querySelector('.faq-inner'));
    initKlaviyoForm(document.getElementById('optin-form'));
  });

  /* ---- SHOPIFY EDITOR EVENTS ---- */
  document.addEventListener('shopify:section:load', function(e) {
    observeFadeUps(e.target);
    var pvid = e.target.querySelector('[id^="pv-"]');
    if (pvid) initVideoLoop(pvid.id, '.product-image-wrap', 0.85);
    var fvid = e.target.querySelector('[id^="fv-"]');
    if (fvid) initVideoLoop(fvid.id, '.feature-image-wrap', 0.55);
    if (e.target.querySelector('.timeline-wrap')) initTimeline(e.target.querySelector('.timeline-wrap'));
    if (e.target.querySelector('.faq-inner')) initFaq(e.target.querySelector('.faq-inner'));
    if (e.target.querySelector('#optin-form')) initKlaviyoForm(e.target.querySelector('#optin-form'));
  });

})();
